// extracted by mini-css-extract-plugin
export default {"alert":"CategoriesEdit_alert__bvdwW"};